import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-965b4d00"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "right-layout"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("td", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "top-title"
}, "权益")]), /*#__PURE__*/_createElementVNode("td", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "top-title-name"
}, "非会员")]), /*#__PURE__*/_createElementVNode("td", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "top-title-name"
}, "普通会员")]), /*#__PURE__*/_createElementVNode("td", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "top-title-name"
}, "永久会员")])], -1));
const _hoisted_3 = {
  class: "rights-item"
};
const _hoisted_4 = {
  class: "rights-item"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  key: 2
};
const _hoisted_8 = {
  class: "rights-item"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  key: 2
};
const _hoisted_12 = {
  class: "rights-item"
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = {
  key: 2
};
import { onMounted, ref } from "vue";
export default {
  __name: 'RightsDisplayComponents',
  setup(__props) {
    const dataList = ref([{
      rightsName: '广告特权',
      normalRights: '有广告',
      vipRights: '无广告',
      superVipRights: '无广告'
    }, {
      rightsName: '创建个数',
      normalRights: '1次/天',
      vipRights: '10次/天',
      superVipRights: '无限制'
    }, {
      rightsName: '修改次数',
      normalRights: '1次',
      vipRights: '无限制',
      superVipRights: '无限制'
    }, {
      rightsName: '扫码次数',
      normalRights: '10次',
      vipRights: '5000次',
      superVipRights: '无限制'
    }, {
      rightsName: '有效期',
      normalRights: '10天',
      vipRights: '360天',
      superVipRights: '永久'
    }, {
      rightsName: '图片容量',
      normalRights: '5M',
      vipRights: '30M',
      superVipRights: '300M'
    }, {
      rightsName: '密码',
      normalRights: 'false',
      vipRights: 'true',
      superVipRights: 'true'
    }, {
      rightsName: '密码修改',
      normalRights: 'false',
      vipRights: 'false',
      superVipRights: 'true'
    }, {
      rightsName: '图片扩容',
      normalRights: 'false',
      vipRights: 'false',
      superVipRights: 'true'
    }]);
    onMounted(() => {
      document.title = '活码会员特权对比';
    });
    const createItemStyle = index => {
      if (index % 2 === 0) {
        return 'background-color: #FEFCF5;';
      }
      return 'background-color: white;';
    };
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("table", null, [_hoisted_2, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item, index) => {
        return _openBlock(), _createElementBlock("tr", {
          key: index,
          style: _normalizeStyle(createItemStyle(index))
        }, [_createElementVNode("td", _hoisted_3, _toDisplayString(item.rightsName), 1), _createElementVNode("td", _hoisted_4, [item.normalRights === 'true' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_van_icon, {
          name: "checked",
          color: "#EDA442",
          size: "20"
        })])) : item.normalRights === 'false' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_van_icon, {
          name: "clear",
          color: "#ADADAD",
          size: "20"
        })])) : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(item.normalRights), 1))]), _createElementVNode("td", _hoisted_8, [item.vipRights === 'true' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_van_icon, {
          name: "checked",
          color: "#EDA442",
          size: "20"
        })])) : item.vipRights === 'false' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_van_icon, {
          name: "clear",
          color: "#ADADAD",
          size: "20"
        })])) : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(item.vipRights), 1))]), _createElementVNode("td", _hoisted_12, [item.superVipRights === 'true' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_van_icon, {
          name: "checked",
          color: "#EDA442",
          size: "20"
        })])) : item.superVipRights === 'false' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_van_icon, {
          name: "clear",
          color: "#ADADAD",
          size: "20"
        })])) : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(item.superVipRights), 1))])], 4);
      }), 128))])]);
    };
  }
};